import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { computed, defineComponent, ref } from 'vue';
import { useVuexStore } from '@/plugins/app-context';
import { roleToLabelMap, YM_HIDE_CONTENT } from '@/shared/constants';
import { useClickOutside, useFocusEvents } from '@/shared/lib';
import { userNameWithInitialsFormatted } from '@/shared/lib/utils/text-utils';
import { NavButton } from '@/shared/ui';
import HeaderProfileDropdown from './HeaderProfileDropdown.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderProfileButton',
  props: {
    dropdownAlign: {
      type: String,
      default: 'end'
    }
  },
  emits: ["item-click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'HeaderProfileButton'
    });
    var menuOpen = ref(false);
    var rootRef = ref(null);
    function onDropdownItemClick() {
      menuOpen.value = false;
      emit('item-click');
    }
    function userMenuButtonClick() {
      menuOpen.value = !menuOpen.value;
    }
    useClickOutside(rootRef, function () {
      menuOpen.value = false;
    });
    useFocusEvents(rootRef, {
      onFocusOutside: function onFocusOutside() {
        menuOpen.value = false;
      }
    });
    var vuexStore = useVuexStore();
    var userInfo = computed(function () {
      var _vuexStore$$auth$$sta;
      // FIXME как-то переделать этот стор на pinia ?
      var _ref2 = (_vuexStore$$auth$$sta = vuexStore.$auth.$state) !== null && _vuexStore$$auth$$sta !== void 0 ? _vuexStore$$auth$$sta : {},
        user = _ref2.user,
        strategy = _ref2.strategy;
      var _ref3 = user !== null && user !== void 0 ? user : {},
        name = _ref3.name,
        surname = _ref3.surname,
        patronymic = _ref3.patronymic;
      return {
        role: roleToLabelMap[strategy],
        name: userNameWithInitialsFormatted(surname, name, patronymic)
      };
    });
    return {
      __sfc: true,
      emit: emit,
      menuOpen: menuOpen,
      rootRef: rootRef,
      onDropdownItemClick: onDropdownItemClick,
      userMenuButtonClick: userMenuButtonClick,
      vuexStore: vuexStore,
      userInfo: userInfo,
      SIcon: SIcon,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT,
      NavButton: NavButton,
      HeaderProfileDropdown: HeaderProfileDropdown
    };
  }
});